// extracted by mini-css-extract-plugin
export var item = "TableOfContents-module--item--3886c";
export var list = "TableOfContents-module--list--7a1fc";